var map = {
	"./abruzzo.svg": 110,
	"./basilicata.svg": 336,
	"./calabria.svg": 58,
	"./campania.svg": 669,
	"./emilia-romagna.svg": 926,
	"./friuli-venezia-giulia.svg": 741,
	"./italy.svg": 146,
	"./lazio.svg": 192,
	"./liguria.svg": 770,
	"./lombardia.svg": 368,
	"./marche.svg": 832,
	"./molise.svg": 718,
	"./piemonte.svg": 249,
	"./puglia.svg": 397,
	"./sardegna.svg": 842,
	"./sicilia.svg": 260,
	"./toscana.svg": 747,
	"./trentino-alto-adige.svg": 100,
	"./umbria.svg": 954,
	"./val-daosta.svg": 584,
	"./veneto.svg": 828
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 124;